import { PAYMENTS_BACKEND_URL } from '@/config';
import axios from '@/lib/axios';
import { Me } from '@/types';

export const getMeInfo = (): Promise<Me> => {
  const endPoint = PAYMENTS_BACKEND_URL + 'auth/me';
  return axios
    .get(endPoint)
    .then((response: any) => {
      if (typeof response === 'string') {
        throw Error(`Critical error fetching data in ${endPoint}`);
      }

      if (response?.status === 404) {
        return null;
      }

      return response;
    })
    .catch((error) => {
      throw Error(`Critical error fetching data in ${endPoint}: ${error}`);
    });
};
